import { useState } from "react";
import { Department } from "@/hooks/queries/useDepartmentQueries";

// Define the employee type from company data
interface CompanyEmployee {
  _id: string;
  id?: string;
  fullName?: string;
  name?: string;
  email: string;
  role?: string;
  departmentId?: string;
  isActive?: boolean;
  isApproved?: boolean;
  companyId?: string;
}

/**
 * Custom hook for managing department modal states
 */
export const useDepartmentModals = () => {
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState<Department | null>(null);

  return {
    showModal,
    setShowModal,
    showDetailModal,
    setShowDetailModal,
    selectedDepartment,
    setSelectedDepartment,
  };
};

/**
 * Custom hook for managing department form states
 */
export const useDepartmentForm = () => {
  const [newDeptName, setNewDeptName] = useState("");
  const [newDeptDesc, setNewDeptDesc] = useState("");
  const [selectedAdminId, setSelectedAdminId] = useState<string>("");

  return {
    newDeptName,
    setNewDeptName,
    newDeptDesc,
    setNewDeptDesc,
    selectedAdminId,
    setSelectedAdminId,
  };
};

/**
 * Custom hook for managing department data states
 */
export const useDepartmentData = () => {
  const [departmentEmployees, setDepartmentEmployees] = useState<CompanyEmployee[]>([]);
  const [departmentCourses, setDepartmentCourses] = useState<string[]>([]);
  const [assigningCourseIds, setAssigningCourseIds] = useState<string[]>([]);

  return {
    departmentEmployees,
    setDepartmentEmployees,
    departmentCourses,
    setDepartmentCourses,
    assigningCourseIds,
    setAssigningCourseIds,
  };
};

/**
 * Custom hook for managing search and filter states
 */
export const useDepartmentFilters = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [employeeSearch, setEmployeeSearch] = useState("");

  return {
    searchTerm,
    setSearchTerm,
    employeeSearch,
    setEmployeeSearch,
  };
};

/**
 * Custom hook for managing loading states
 */
export const useDepartmentLoading = () => {
  const [loadingDepartments, setLoadingDepartments] = useState<Set<string>>(new Set());
  const [loadingEmployees, setLoadingEmployees] = useState<Set<string>>(new Set());
  const [loadingAdmins, setLoadingAdmins] = useState<Set<string>>(new Set());

  return {
    loadingDepartments,
    setLoadingDepartments,
    loadingEmployees,
    setLoadingEmployees,
    loadingAdmins,
    setLoadingAdmins,
  };
};
